<template>
   <header id="admin_header">
      <h1 id="logo">
         <img src="@/assets/img/layout/admin_logo.svg" alt="Admin Logo">
      </h1>

      <div class="lnb">
         <ul>
            <li v-for="( item, index ) in lnbData" :key="index">
               <a href="javascript:void(0);" class="dp1" @click="depthCurrentHandler(item.path,$event)">{{ item.name }}</a>
               <ul class="dp2">
                  <li v-for=" ( item2, index2 ) in item.children " :key="index2">
                     <a href="javascript:void(0);" @click="depth2CHandler(item2.path, $event)">{{ item2.name }}</a>
                  </li> 
               </ul>
            </li>
         </ul>
      </div>
   </header>

</template>

<script>
   import { lnbData } from "@/data/GnbMenuList"
   export default {
      name: "AdminLnb",
      data() {
         return {
            clickEvent1: 0,      // depth1 Click Event
            clickEvent2: 0,      // depth2 Click Event
            lnbData: lnbData
         }
      },
      created() {
         console.log("@@@ 메뉴생성");
      },
      methods: {
         depthCurrentHandler : function(path,e){
            let depth1 = document.querySelectorAll('.lnb > ul > li'); 
            let target = e.target.parentElement;
            if(target.className != "on"){
               for ( let i = 0; i < depth1.length; i++){ // 뎁스 갯수 만큼
                  depth1[i].classList.remove('on');
               }
               target.classList.add('on');
            }else{
               target.classList.remove('on');
            }

            if(path != "" && path != null){
               this.$router.push(path);
            }
         },
         depth2CHandler : function(path,e){
            let depth2 = document.querySelectorAll('.lnb .dp2 > li');
            let target = e.target.parentElement;

            console.log("@@@@ path :"+path);            

            if(target.className != "active"){
               for ( let i = 0; i < depth2.length; i++){
                  depth2[i].classList.remove('active');
               }
               target.classList.add('active');
            }else{
               target.classList.remove('active');
            }

            if(path != "" && path != null){
               this.$store.dispatch('commonStore/setCommonStoreInit');
               this.$router.push(path);
            }
         },
      }
   }
</script>